import { Modal, Space } from 'antd';
import { ModalProps } from 'antd/lib/modal';
import classNamesUtil from 'classnames';
import { PropsWithChildren, useMemo } from 'react';
import SZButton from '../SZButton';
import styles from './index.less';

interface Props extends ModalProps {
  OKBtnDisable?: boolean;
}

const SZModal = (props: PropsWithChildren<Props>) => {
  const {
    children,
    className,
    onCancel,
    onOk,
    centered = true,
    OKBtnDisable = false,
    footer,
    visible,
    open,
    ...rest
  } = props;

  const classNames = useMemo(
    () => classNamesUtil(className, styles['modal-wrapper']),
    [className],
  );

  const CustomFooter = useMemo(() => {
    if (footer || footer === null) return footer;
    return (
      <Space>
        <SZButton type="secondary" onClick={onCancel}>
          取消
        </SZButton>
        <SZButton onClick={onOk} disabled={OKBtnDisable}>
          确定
        </SZButton>
      </Space>
    );
  }, [OKBtnDisable, footer, onCancel, onOk]);

  return (
    <Modal
      // maskStyle={{
      //   background: 'rgba(0,0,0,0.1)',
      // }}
      centered={centered}
      getContainer={document.querySelector('#portal') as HTMLElement}
      open={visible || open}
      className={classNames}
      footer={CustomFooter}
      onCancel={onCancel}
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default SZModal;
